import apiClient from "api-client";
import { ADMIN_USER } from "api-client/endpoints";

export const handleImpersonating = async (id) => await apiClient.get(ADMIN_USER, { id });

export const formatLocation = (location) =>
  [
    location?.line1,
    location?.city,
    location?.countrySubDivisionCode,
    location?.postalCode,
    location?.country,
  ]
    .filter(Boolean)
    .join(", ");

export function getLocationObject(place) {
  if (typeof place === "string") return place;

  const defaultResult = {
    city: "",
    country: "",
    line1: "",
    postalCode: "",
    lat: "",
    long: "",
    countrySubDivisionCode: "",
  };

  if (!place || !place.address_components) return defaultResult;

  const getComponent = (type) =>
    place.address_components.find((component) => component.types.includes(type))?.long_name || "";

  const line1 = place.name || "";
  const city = getComponent("locality") || getComponent("sublocality");
  const state = getComponent("administrative_area_level_1");
  const postalCode = getComponent("postal_code");
  const country = getComponent("country");

  return {
    line1,
    city,
    countrySubDivisionCode: state,
    postalCode,
    country,
    lat: place.geometry?.location?.lat(),
    long: place.geometry?.location?.lng(),
  };
}
